<template>
  <a-drawer placement="right" :closable="false" :mask-closable="false" :visible="visible" width="1200" :body-style="{'padding':'12px','box-sizing':'border-box','height':'92%','overflow':'auto'}">
    <div slot="title" class="gpws-drawer-title-span">
      <div class="gpws-drawer-close" @click="()=>onDrawerClose()"><a-icon type="close" style="margin-right: 3px" />关闭</div>
      <span class="gpws-drawer-title">方剂大全</span>
      <span></span>
    </div>
    <a-spin :spinning="loading" :tip="loadTip">
      <a-form>
        <a-row>
          <a-col span="6">
            <a-form-item label="方剂名" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }">
              <a-input v-model="search.keyword" placeholder="请输入方剂名称模糊检索" @keyup.enter="searchAction"/>
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item label="症状" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }">
              <a-input v-model="search.symptom" placeholder="请输入方剂症状模糊检索" @keyup.enter="searchAction"/>
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item label="证候" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }">
              <a-input v-model="search.syndrome" placeholder="请输入方剂证候模糊检索" @keyup.enter="searchAction"/>
            </a-form-item>
          </a-col>
          <a-col span="6">
            <img src="../../assets/img/s-search.png" style="user-select: none;cursor: pointer;margin-right: 10px;margin-top: 4px;" @keyup.enter="searchAction" @click="searchAction"/>
          </a-col>
        </a-row>
      </a-form>
      <a-table :bordered="true" size="middle" :columns="grid.columns" rowKey="id" @change="gridChangeAction" :dataSource="grid.data" :scroll="{ x: '100%' }" :pagination="grid.pagination">
        <a-tag slot="name" slot-scope="text, record" color="blue" style="width: 120px;min-height: 32px;white-space: normal;display: inline-grid;">{{ record.name }}</a-tag>
        <span slot="symptoms" slot-scope="text, record" style="white-space:pre-wrap;word-wrap:break-word;overflow:hidden;">
          <template v-if="(undefined != record.symptom && null != record.symptom && '' != record.symptom)">
            {{ record.symptom }}
          </template>
          <span v-else>-</span>
        </span>
        <span slot="drugs" slot-scope="text, record">
          {{ (record.drugs||[]).map(m => m.name).join("、") }}
        </span>
        <span slot="operate" slot-scope="text, record">
          <img src="../../assets/img/recipe.png" v-if="(record.drugs||[]).length > 0" style="cursor: pointer;user-select: none;" @click="recipeAction(record.id)"/>
          <img src="../../assets/img/detail.png" style="cursor: pointer;user-select: none;margin-left: 12px;" @click="detailAction(record.id)"/>
        </span>
      </a-table>
      <encyclopedia-detail ref="detail"/>
    </a-spin>
  </a-drawer>
</template>

<script>
import EncyclopediaDetail from '@/components/prescription/EncyclopediaDetail.vue';
export default {
  name: "EncyclopediaDrawer",
  components:{
    EncyclopediaDetail
  },
  data(){
    return {
      visible:false,
      loading:false,
      loadTip:'正在查询方剂信息....',
      search:{
        syndrome:'',
        symptom:'',
        keyword:''
      },
      grid:{
        data: [],
        pagination: this.$pagination,
        columns:[{
          title: '证候',
          dataIndex: 'syndrome',
          align: 'center',
          key: 'syndrome',
          width: 100,
          customRender:(text, record, index) =>{
            return text == undefined || text == null || text == '' ? '-' : text;
          }
        },{
          title: '方名',
          dataIndex: 'name',
          align: 'center',
          key: 'name',
          width: 150,
          scopedSlots: { customRender: 'name'}
        },
        {
          title: '症状',
          dataIndex: 'symptom',
          key: 'symptom',
          scopedSlots: { customRender: 'symptoms'}
        },
        {
          title: '药品',
          key: 'drugs',
          width: 300,
          scopedSlots: { customRender: 'drugs'}
        },
        {
          title: '操作',
          key: 'operate',
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'operate'}
        }]
      }
    }
  },
  methods:{
    showEncyclopediaDrawer:function (){
      this.grid.pagination.total=0;
      this.search.keyword='四物汤';
      this.searchAction();
      this.visible = true;
    },
    onDrawerClose:function (){
      this.visible = false;
    },
    detailAction:function (id) {
      this.$refs.detail.showModal(id);
    },
    recipeAction:function(id){
      this.$emit('clickit', id);
      this.onDrawerClose();
    },
    buildParams:function (){
      return { 'entity.syndrome' : this.search.syndrome, 'entity.symptom' : this.search.symptom, 'entity.keyword' : this.search.keyword, 'entity.status' : 'ENABLED' };
    },
    /**
     * 查询按钮动作
     */
    searchAction: function () {
      Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
      let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 分页条操作
     */
    gridChangeAction: function (pagination, filters, sorter) {
      Object.assign(this.grid, {pagination: pagination});
      let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 查询
     */
    loadGrid:function(params){
      const self = this;
      self.loading = true;
      self.$axios.get('/api/clinic/encycs', {params: params}).then(function(res){
        self.loading = false;
        if(res.msg.flag == 0){
          if(null == res.biz || res.biz.empty){
            self.$message.info({content: res.msg.message, duration: 2});
            Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
          }else{
            Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(){
        self.loading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>
